package com.pincer.app.viewmodel

import com.pincer.app.ApplicationState
import com.pincer.app.I18n
import com.pincer.core.functions.validateServerUrl
import com.pincer.core.functions.validateWebSocketUrl
import com.pincer.core.functions.validatePrincipalName

fun appSettings(state: ApplicationState, context: Node) {
    context.opening(state = state, key = "settings", atFirst = false, prominence = Prominence.Secondary) {
        if (state.personalIsReady()) {
            node("account") {

                missingCredentials(state, this)

                if (state.personalSelf()!!.name != null) {
                    node("yourName") {
                        node("value", state.personalSelf()!!.name!!)
                    }
                }

                if (state.personalPincer()!!.name != null) {
                    val credentialLabel = if (state.personalPincer()!!.name!!.contains("@")) "emailAddress" else "phoneNumber"
                    node(credentialLabel) {
                        node("value", state.personalPincer()!!.name!!)
                    }
                }

                button(key = "logoutThisDevice", action = Action.LogoutThisDevice)
                button(key = "logoutAllDevices", action = Action.LogoutAllDevices)
            }
        }
        node("locale") {
            val controlChoices = mapOf(
                "en-GB" to I18n.translate("en-GB"),
                "en-US" to I18n.translate("en-US"),
                "es"    to I18n.translate("es"),
                "fr"    to I18n.translate("fr"),
            )
            select(key = "setLocale", action = Action.SetLocale, wording = state.locale(), controlChoices = controlChoices)
        }
        node("zone") {
            val controlChoices = mapOf(
                "Europe/Amsterdam" to "Europe/Amsterdam",
                "Europe/Athens" to "Europe/Athens",
                "Europe/Belgrade" to "Europe/Belgrade",
                "Europe/Berlin" to "Europe/Berlin",
                "Europe/Dublin" to "Europe/Dublin",
                "Europe/Istanbul" to "Europe/Istanbul",
                "Europe/Kyiv" to "Europe/Kyiv",
                "Europe/Lisbon" to "Europe/Lisbon",
                "Europe/London" to "Europe/London",
                "Europe/Madrid" to "Europe/Madrid",
                "Europe/Moscow" to "Europe/Moscow",
                "Europe/Paris" to "Europe/Paris",
                "Europe/Prague" to "Europe/Prague",
                "Europe/Rome" to "Europe/Rome",
                "Europe/Stockholm" to "Europe/Stockholm",
                "Europe/Tallinn" to "Europe/Tallinn",
                "Europe/Vienna" to "Europe/Vienna",
                "Europe/Zurich" to "Europe/Zurich",
                "GMT" to "GMT",
                "US/Alaska" to "US/Alaska",
                "US/Central" to "US/Central",
                "US/Eastern" to "US/Eastern",
                "US/Hawaii" to "US/Hawaii",
                "US/Michigan" to "US/Michigan",
                "US/Mountain" to "US/Mountain",
                "US/Pacific" to "US/Pacific",
            )
            select(key = "setZone", action = Action.SetZone, wording = state.zone(), controlChoices = controlChoices)
        }
        node("showAdvancedOptions") {
            checkbox(key = "setShowAdvancedOptions", action = Action.SetShowAdvancedOptions, wording = state.stored.showAdvancedOptions)
            helpText("showAdvancedOptionsHelpText")
        }
        if (state.stored.showAdvancedOptions == "true") {
            val serverProblem = validateServerUrl(state.stored.serverUrl)
            field(state = state, key = "serverUrl", value = state.stored.serverUrl, problem = serverProblem) {
                input(key = "setServerUrl", action = Action.SetServerUrl, wording = state.stored.serverUrl, problem = serverProblem)
                possibleProblem(serverProblem)
            }
            val webSocketProblem = validateWebSocketUrl(state.stored.webSocketUrl)
            field(state = state, key = "webSocketUrl", value = state.stored.webSocketUrl, problem = webSocketProblem) {
                input(key = "setWebSocketUrl", action = Action.SetWebSocketUrl, wording = state.stored.webSocketUrl, problem = webSocketProblem)
                possibleProblem(webSocketProblem)
            }
            button(key = "resetDevice", action = Action.ResetDevice)
        }
    }
}
